import React from "react";
import PieChart from "../../PieChart";
import { TICKET_SLA } from "../SLAUtils";
import { statusCategories } from "../../../../Findings/FindingDetailsPane/FindingDetailsPaneHeader/Statuses/StatusUtils";
import type { SelectedScope } from "../../../../types/scope";

export interface TicketDueDateProps {
  selectedScope?: SelectedScope | null;
  filterToExecute?: string | null;
  scopeToExecute?: string | null;
  id?: string;
  setIsReadyToExport?: ((isReady: boolean) => void) | null;
}

const TicketDueDate: React.FC<TicketDueDateProps> = ({
  selectedScope,
  filterToExecute,
  scopeToExecute,
  id,
  setIsReadyToExport,
}) => {
  const filtersConfig = {
    filtersjson: filterToExecute || null,
    scopesjson: scopeToExecute || null,
    scopesid: selectedScope?.value?.id,
  };

  const chartFilterValue = [
    {
      type: "category",
      key: statusCategories.OPEN,
      id: statusCategories.OPEN,
    },
  ];

  const skip =
    (!scopeToExecute && !selectedScope?.value?.id) || !filterToExecute;

  const chartName = `TicketDueDatesDiv-${id}`;

  return (
    <PieChart
      categories={TICKET_SLA}
      skip={skip}
      groupBy={["ticket.ticket_due_date_status"]}
      filtersConfig={filtersConfig}
      legendTitle={"Due Date Status"}
      chartName={chartName}
      chartFilterValue={chartFilterValue}
      actualFilterField={"ticket_due_date_status"}
      dataSubject={"Tickets"}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default TicketDueDate;
